import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import * as _ from 'underscore';
import { RootStoreState } from 'src/app/root-store';
import { takeUntil } from 'rxjs/operators';

import { getQuote, getQuoteError, getQuoteLoading } from 'src/app/root-store/kwikspace-app-store/selectors/quote.selector';
import { GetQuote } from 'src/app/root-store/kwikspace-app-store/actions/quote.action';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'kwikspace-view-quote',
  templateUrl: './view-quote.component.html',
  styleUrls: ['./view-quote.component.scss']
})
export class ViewQuoteComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();

  quoteLoading$: Observable<any> = this.store.select(getQuoteLoading);
  quoteError$: Observable<any> = this.store.select(getQuoteError);

  quote;
  quoteId;
  quoteType: string = '';

  constructor(
    private store: Store<RootStoreState.RootState>,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    const { params } = this.route.snapshot;
    this.quoteId = params.id;

    this.store
      .select(getQuote)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quote) => {
        if (quote) {
          this.quote = quote;
          this.quoteType = this.quote.quoteType;
        }
      });
    this.store.dispatch(new GetQuote(this.quoteId));
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
